import { targetSetupStore } from "./target-setup.store";
import { targetSetupUIStore } from "./target-setup-ui.store";

export { targetSetupStore, targetSetupUIStore };

export const resetAllStores = () => {
  targetSetupStore.reset();
  targetSetupUIStore.reset();
};
